import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B05PurchaseOrderPage } from '../b05-purchase-order/b05-purchase-order';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
/**
 * Generated class for the B05bPurchaseAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
interface supplierInfo{
  SUPPLIER_ID: number;
  SUPPLIER_NAME: string;
}

interface supplier_statusInfo{
  SUPPLIER_STATUS_ID: number;
  STATUS: string;
}

interface currencyInfo{
  CURRENCY_ID: number;
  CODE: string;
  RATE: string;
  DATETIME: string;
}
interface inventoryInfo{
  INVENTORY_ID: number;
  INVENTORY_ITYPE_ID: number;
  ITEM_DESC: string;
  COST: string;
  SELLING_PRICE: string;
  INVENTORY_ACTIVE: string;
}
interface branchInfo{};
@IonicPage()
@Component({
  selector: 'page-b05b-purchase-add',
  templateUrl: 'b05b-purchase-add.html',
})
export class B05bPurchaseAddPage {
  loading: any;
  Status: any;
  Date: any;

  //SUPPLIER
  supplierArr: supplierInfo[] = [];
  supplierItems: supplierInfo[] = [];
  supplier_statusArr: supplier_statusInfo[] = [];
  supplier_statusItems: supplier_statusInfo[] = [];
  supplier_id:any;
  supplier_type:any;
  supplier_type_id:any;
  //CURRENCY
  currencyArr: currencyInfo[] = [];
  currencyItems: currencyInfo[] = [];
  currency_code:any;
  currency_rate:any;
  currency_id:any;
  //INVENTORY
  inventoryArr: inventoryInfo[] = [];
  inventoryItems: inventoryInfo[] = [];
  inventoryId:any = "";
  userName:any;
  userId:any;
  //BRANCH
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  private todo : FormGroup;
  public errorMessage: any = "";
  POL_Array = [];
  DATA_Array = [];
  SUBMIT_Array = [];
  userBranchId:any;
  POsubtotal:any;
  POtaxtotal:any;
  POgrandtotal:any;
  branch_id:any;
  overlayHidden: boolean = true;
  purchaseData = {  Date:'', Action_By:'',
                Supplier:'', Code:'',
                Remark:'',Description:'',
                Quantity:'',UnitCost:'',
                DiscPercentage:'',
                TaxPercentage:''

  }
  GRP_ID:any;
  branch_name:any;
  getbranchid:any="";
  getinvid:any="";
  selectedItem:any;
  selectedDescription:any;
  selectedQuantity:any;
  selectedUnitCost:any;
  selectedDiscPercentage:any;
  selectedTaxPercentage:any;
  selected_id:any;
  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public serviceapi:ServiceApiProvider,public loadingCtrl: LoadingController) {
    this.getbranchid = this.navParams.get('param1'); 
    this.getinvid = this.navParams.get('param2'); 
    //this.POL_JSON("POL_DESC","QTY","UNIT_PRICE","DISC_PERC","TAX_PERC","TOTAL_TAX","POL_TOTAL","GRAND_POL_TOTAL","INVENTORY_ID");
    //this.POL_JSON("POL_DESC1","QTY","UNIT_PRICE","DISC_PERC","TAX_PERC","TOTAL_TAX","POL_TOTAL","GRAND_POL_TOTAL","INVENTORY_ID");
    //this.POL_JSON("POL_DESC2","QTY","UNIT_PRICE","DISC_PERC","TAX_PERC","TOTAL_TAX","POL_TOTAL","GRAND_POL_TOTAL","INVENTORY_ID");
    //this.DATA_JSON("1","DATETIME","ACTION_BY","PO_TYPE_ID","SUPPLIER_ID","BRANCH_ID","CURRENCY_ID","REMARKS",this.POL_Array)
    this.GRP_ID = sessionStorage.getItem('usergroupid');
    this.userBranchId = sessionStorage.getItem('userbranchid');
    if(this.getbranchid == null)
    {
      console.log("AAAAA");
    }
    else
    {
      console.log("BBBBBB");
    }
    
  
      if(this.GRP_ID=="1") {            //system admin
        this.todo = this.formBuilder.group({
          suppliercode: [''],
          remark: [''],
          branch: ['', Validators.required],
          supplier: ['', Validators.required],
          currency: ['', Validators.required],
          description: [''],
          inventory:[''],
          quantity: [''],
          unitCost: [''],
          taxPercentage:[''],
          discPercentage: [''],
          });
      }
      else if ((this.GRP_ID == "2") || (this.GRP_ID == "3")) {      //corporate admin/ manager
        this.todo = this.formBuilder.group({
          suppliercode: [''],
          remark: [''],
          branch: [''],
          supplier: ['', Validators.required],
          currency: ['', Validators.required],
          description: [''],
          inventory:[''],
          quantity: [''],
          unitCost: [''],
          taxPercentage:[''],
          discPercentage: [''],
          });
      }
      this.userId = sessionStorage.getItem('userid');
      this.userName = sessionStorage.getItem('username');
      console.log(this.userId+" -- "+this.userName);
      this.showLoader();
      //Read Supplier Info
      let tbl = ["SUPPLIER"];
      let column = ["SUPPLIER_STATUS_ID"];
      let value = ["2"];

      let tblkey = ["SUPPLIER_TYPE_ID"];
      let fktbl = ["SUPPLIER_TYPE"];
      let fkkey = ["SUPPLIER_TYPE_ID"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");


      this.serviceapi.readdata(json_data,"SUPPLIER","1","1").then((result) => {
       
        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.supplierArr = Records;
          this.supplierItems = this.supplierArr;
         console.log(this.supplierItems)

          /*let tbl = ["All"];
          let column = ["All"];
          let value = ["All"];

          let tblkey = ["No"];
          let fktbl = ["No"];
          let fkkey = ["No"];

          let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

          let mydata = Object.assign(jsonitem);
          let json_data = this.serviceapi.json_readdata(mydata,"1");
          */

          this.serviceapi.serverdatetime().then((result) => {
           
            this.Status = result["Message"];
            if (this.Status == '1'){
              
              this.Date = result["Date"];
             
              
              //Start  
              let tbl = ["All"];
              let column = ["All"];
              let value = ["All"];
        
              let tblkey = ["No"];
              let fktbl = ["No"];
              let fkkey = ["No"];
        
              let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
        
              let mydata = Object.assign(jsonitem);
              let json_data = this.serviceapi.json_readdata(mydata,"1");
        
        
              this.serviceapi.readdata(json_data,"CURRENCY","1","1").then((result) => {
               
                this.Status = result["Message"];
                if (this.Status == '1'){
                  
                  let Records = result["Records"];
                  this.currencyArr = Records;
                  this.currencyItems = this.currencyArr;
                  console.log(this.GRP_ID);
                  let temp_tbl;
                  let temp_col;
                  let temp_val;
                  if(this.GRP_ID == '1')
                  {
                    if(this.getbranchid != null)
                    {
                      temp_tbl = ["INVENTORY"];
                      temp_col = ["BRANCH_ID"];
                      temp_val = [this.getbranchid];
                      console.log("ENTER")
                    }
                    else
                    {
                    
                      temp_tbl = ["All"];
                      temp_col = ["All"];
                      temp_val = ["All"];
                     
                    }
                  }
                  else if(this.GRP_ID == '2' || this.GRP_ID == '3' || this.GRP_ID == '4')  
                  {
                    temp_tbl = ["INVENTORY"];
                    temp_col = ["BRANCH_ID"];
                    temp_val = [this.userBranchId];
                  }

                  let tbl = temp_tbl;
                  let column = temp_col;
                  let value = temp_val;

                  let tblkey = ["No"];
                  let fktbl = ["No"];
                  let fkkey = ["No"];
            
                  let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
                  console.log(jsonitem);
                  let mydata = Object.assign(jsonitem);
                  let json_data = this.serviceapi.json_readdata(mydata,"1");
            
            
                  this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
                    
                    this.Status = result["Message"];
                    if (this.Status == '1'){
                      
                      let Records = result["Records"];
                      this.inventoryArr = Records;
                      this.inventoryItems = this.inventoryArr;
                      if(this.getbranchid != null)
                      {
                        this.purchaseData.UnitCost = this.inventoryItems[0]['COST'];
                      }
                      let temp_tbl = [];
                      let temp_column = [];
                      let temp_value = [];
                  
                      if(this.GRP_ID=="1") {            //system admin
                        temp_tbl = ["All"];
                        temp_column = ["All"];
                        temp_value = ["All"];
                      }
                      else if ((this.GRP_ID == "2") || (this.GRP_ID == "3")) {      //corporate admin/ manager
                        temp_tbl = ["BRANCH"]; 
                        temp_column = ["BRANCH_ID"];
                        temp_value = [this.userBranchId];
                      }
                  
                      let tbl = temp_tbl;
                      let column = temp_column;
                      let value = temp_value;
                
                      let tblkey = ["No"];
                      let fktbl = ["No"];
                      let fkkey = ["No"];
                
                      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
                
                      let mydata = Object.assign(jsonitem);
                      let json_data = this.serviceapi.json_readdata(mydata,"1");
                
                
                      this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
                        
                        this.Status = result["Message"];
                        if (this.Status == '1'){
                          
                          let Records = result["Records"];
                          console.log(Records);
                          if(this.GRP_ID=="1") {      
                            this.branchArr = Records;
                            this.branchItems = this.branchArr;
                          }
                          else if(this.GRP_ID == "2" || this.GRP_ID == "3")
                          {
                           let val = Records[0];
                            this.branch_name = val["BRANCH_NAME"];
                          }
                          if(this.getinvid != null)
                          {
                            let val = this.inventoryItems.find(c => c.INVENTORY_ID === this.getinvid);
                            this.purchaseData.UnitCost = val["COST"];
                            this.inventoryId = val["INVENTORY_ID"];
                            console.log("A");
                          }
                          this.loading.dismiss();
                          
                          
                        }
                        else {
                          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                          this.loading.dismiss();
                        }
                      }, (err) => {
                        this.errorMessage = "Loading Error. Please try again.";
                        this.loading.dismiss();
                      });
            
                    }
                    else {
                      this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                      this.loading.dismiss();
                    }
                  }, (err) => {
                    this.errorMessage = "Loading Error. Please try again.";
                    this.loading.dismiss();
                  });
                  
        
                 
                }
                else {
                  this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                  this.loading.dismiss();
                }
              }, (err) => {
                this.errorMessage = "Loading Error. Please try again.";
                this.loading.dismiss();
              });
              //End            
            }
            else {
              this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
              this.loading.dismiss();
            }
          }, (err) => {
            this.errorMessage = "Loading Error. Please try again.";
            this.loading.dismiss();
          });
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          this.loading.dismiss();
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
      });
      
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B05bPurchaseAddPage');
  }

  goTo(){
    this.navCtrl.setRoot(B05PurchaseOrderPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }

  POL_JSON(POL_DESC,QTY,UNIT_PRICE,DISC_PERC,TAX_PERC,TOTAL_TAX,POL_TOTAL,GRAND_POL_TOTAL,INVENTORY_ID)
  {
      let POL = {	
        POL_DESC:"",
        QTY:"",
        UNIT_PRICE:"0",
        DISC_PERC:"0",
        TAX_PERC:"0",
        TOTAL_TAX:"0",
        POL_TOTAL:"0",
        GRAND_POL_TOTAL:"0",
        INVENTORY_ID:""
      }
      
      POL.POL_DESC = POL_DESC;
      POL.QTY = QTY;
      POL.UNIT_PRICE = UNIT_PRICE;
      if(DISC_PERC == "")
        POL.DISC_PERC = "0";
      else
        POL.DISC_PERC = DISC_PERC;
      if(TAX_PERC == "")
        POL.TAX_PERC = "0";
      else
        POL.TAX_PERC = TAX_PERC;
      POL.TOTAL_TAX = TOTAL_TAX;
      console.log("TOTAL"+POL.TOTAL_TAX);
      POL.POL_TOTAL = POL_TOTAL;
      POL.GRAND_POL_TOTAL = GRAND_POL_TOTAL;
      POL.INVENTORY_ID = INVENTORY_ID;
      this.POL_Array.push(POL)
      
  }

  DATA_JSON(RUNNO,DATETIME,ACTION_BY,PO_TYPE_ID,SUPPLIER_ID,BRANCH_ID,CURRENCY_ID,REMARKS,POL,PO_STATUS_ID)
  {
      let DATA = {
				RunNo:"",
				DATETIME:"",
				POL_Total:0,
				ACTION_BY:"",
				PO_TYPE_ID:"",
				SUPPLIER_ID:"",
				BRANCH_ID:"",
        CURRENCY_ID:"",
        PO_STATUS_ID:"",
				REMARKS:"",
				POL:[]
      }
      DATA.RunNo = RUNNO;
      DATA.DATETIME = DATETIME;
      DATA.POL_Total = (this.POL_Array).length;
      DATA.ACTION_BY = ACTION_BY;
      DATA.PO_TYPE_ID = PO_TYPE_ID;
      DATA.SUPPLIER_ID = SUPPLIER_ID;
      DATA.BRANCH_ID = BRANCH_ID;
      DATA.CURRENCY_ID = CURRENCY_ID;
      DATA.REMARKS = REMARKS;
      DATA.POL = POL;
      DATA.PO_STATUS_ID = PO_STATUS_ID;
      /*POL.POL_DESC = POL_DESC;
      POL.QTY = QTY;
      POL.UNIT_PRICE = UNIT_PRICE;
      POL.DISC_PERC = DISC_PERC;
      POL.TAX_PERC = TAX_PERC;
      POL.TOTAL_TAX = TOTAL_TAX;
      POL.POL_TOTAL = POL_TOTAL;
      POL.GRAND_POL_TOTAL = GRAND_POL_TOTAL;
      POL.INVENTORY_ID = INVENTORY_ID;*/
      this.DATA_Array.push(DATA);
     
  }

  SUBMIT_JSON(USERID,DATA)
  {
      let COMPILE_DATA = {
				Param:"",
				UserID:"",
				Total:0,
				Data:[]
      }
      COMPILE_DATA.Param = "1";
      COMPILE_DATA.UserID = USERID;
      COMPILE_DATA.Total =  (this.DATA_Array).length;
      COMPILE_DATA.Data = DATA;

      
      //this.SUBMIT_Array.push(COMPILE_DATA);
      /*POL.POL_DESC = POL_DESC;
      POL.QTY = QTY;
      POL.UNIT_PRICE = UNIT_PRICE;
      POL.DISC_PERC = DISC_PERC;
      POL.TAX_PERC = TAX_PERC;
      POL.TOTAL_TAX = TOTAL_TAX;
      POL.POL_TOTAL = POL_TOTAL;
      POL.GRAND_POL_TOTAL = GRAND_POL_TOTAL;
      POL.INVENTORY_ID = INVENTORY_ID;
      this.POL_Array.push(POL)*/
     return COMPILE_DATA;
  }
  onChange(data)
  {
   let val = this.supplierItems.find(c => c.SUPPLIER_ID === data);
   this.supplier_id = val["SUPPLIER_ID"];
   this.supplier_type = val["TYPE"];
   this.supplier_type_id  = val["SUPPLIER_TYPE_ID"];
  }
  onChangeBranch(data)
  {
   let val = this.branchItems.find(c => c["BRANCH_ID"] === data);
   this.branch_id = val["BRANCH_ID"];
   this.inventoryItems = [];
   let tbl = ["INVENTORY"];
   let column = ["BRANCH_ID"];
   let value = [this.branch_id];

   let tblkey = ["No"];
   let fktbl = ["No"];
   let fkkey = ["No"];

   let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

   let mydata = Object.assign(jsonitem);
   let json_data = this.serviceapi.json_readdata(mydata,"1");


   this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
     
     this.Status = result["Message"];
     if (this.Status == '1'){
       
       let Records = result["Records"];
       this.inventoryArr = Records;
       this.inventoryItems = this.inventoryArr;
       
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });

   //this.supplier_type = val["TYPE"];
   //this.supplier_type_id  = val["SUPPLIER_TYPE_ID"];
  }
  onChangeCurrency(data)
  {
    let val = this.currencyItems.find(c => c.CURRENCY_ID === data);
    this.currency_id = val["CURRENCY_ID"];
    this.currency_code = val["CODE"];
    this.currency_rate = val["RATE"];
  }

  showdescname(data)
  {
   let val = this.inventoryItems.find(c => c["INVENTORY_ID"] === data);
   return val["ITEM_DESC"];
   //this.supplier_type = val["TYPE"];
   //this.supplier_type_id  = val["SUPPLIER_TYPE_ID"];
  }
  onChangeInventory(data)
  {
    let val = this.inventoryItems.find(c => c.INVENTORY_ID === data);
    this.purchaseData.UnitCost = val["COST"];
    this.inventoryId = val["INVENTORY_ID"];
    console.log(this.purchaseData.UnitCost);
  }

  addCost()
  {
    let TOTAL_TAX = this.taxCalculate();
    let POL_TOTAL = this.polCalculate();
    let QTY_UNIT = (parseFloat(this.purchaseData.Quantity)*parseFloat(this.purchaseData.UnitCost));
    console.log("Tax"+TOTAL_TAX);
    console.log("POl"+POL_TOTAL);
    let GRAND_POL_TOTAL = QTY_UNIT + TOTAL_TAX - POL_TOTAL;
    console.log("GRAND_POL_TOTAL"+GRAND_POL_TOTAL);
                                                                                         
    this.POL_JSON(this.purchaseData.Description,this.purchaseData.Quantity,this.purchaseData.UnitCost,this.purchaseData.DiscPercentage,this.purchaseData.TaxPercentage,TOTAL_TAX,QTY_UNIT,GRAND_POL_TOTAL,this.inventoryId);
    this.purchaseData.Description = "";
    this.purchaseData.Quantity = "";
    this.purchaseData.UnitCost = "";
    this.purchaseData.DiscPercentage = "";
    this.purchaseData.TaxPercentage = "";
    this.inventoryId = null;

    this.POsubtotal = this.subtotal();
    this.POtaxtotal = this.taxtotal();
    this.POgrandtotal = this.grandtotal();
  }

  taxCalculate()
  {
    if(this.purchaseData.TaxPercentage == "")
      return 0;
    else
      return ((parseFloat(this.purchaseData.Quantity)*parseFloat(this.purchaseData.UnitCost))*((parseFloat(this.purchaseData.TaxPercentage)/100)));
  }
  polCalculate()
  {
    if(this.purchaseData.DiscPercentage == "")
      return 0;
    else
      return ((parseFloat(this.purchaseData.Quantity)*parseFloat(this.purchaseData.UnitCost))*((parseFloat(this.purchaseData.DiscPercentage)/100)));
  }
  subtotal()
  {
    let i = 0;
    let subtotal = 0;
    for(i=0;i<this.POL_Array.length;i++)
    {
      let data = this.POL_Array[i];
      subtotal = subtotal + data['POL_TOTAL'];
    }

    return subtotal;
  }

  taxtotal()
  {
    let i = 0;
    let taxtotal = 0;
    for(i=0;i<this.POL_Array.length;i++)
    {
      let data = this.POL_Array[i];
      taxtotal = taxtotal + data['TOTAL_TAX'];
    }
    return taxtotal;
  }
  
  grandtotal()
  {
    let i = 0;
    let grandtotal = 0;
    for(i=0;i<this.POL_Array.length;i++)
    {
      let data = this.POL_Array[i];
      grandtotal = grandtotal + data['GRAND_POL_TOTAL'];
    }
    return grandtotal;
  }
  
  adddata(data, print)
  {
    
    if(this.POL_Array.length != 0)
    {
      this.showLoader();
      this.serviceapi.serverdatetime().then((result) => {
        
        this.Status = result["Message"];
        if (this.Status == '1'){
          let branch="";
          if(this.GRP_ID=="1") {            //system admin
            branch = this.branch_id;
          }
          else if ((this.GRP_ID == "2") || (this.GRP_ID == "3")) {      //corporate admin/ manager
            branch = this.userBranchId;
          }
          this.Date = result["Date"] +" "+ result["Time"];
          if(branch != "null")
          {
                if(this.POL_Array.length == 0)
                  this.DATA_JSON("0",this.Date, this.userId,this.supplier_type_id,this.supplier_id,branch,this.currency_id,this.purchaseData.Remark,"",data);
                else
                  this.DATA_JSON("0",this.Date, this.userId,this.supplier_type_id,this.supplier_id,branch,this.currency_id,this.purchaseData.Remark,this.POL_Array,data);
              
                let value = this.SUBMIT_JSON(this.userId,this.DATA_Array);
                console.log(value);
                this.serviceapi.purchaseorderdata(value).then((result) => {
                  this.loading.dismiss();
                  this.Status = result["Message"];
                  let Last_ID = result["PO_ID"];
                  if(print == 1)
                  {
                    console.log(this.Status);
                    if (this.Status == '1'){
                    
                      this.serviceapi.printDocument('1',Last_ID,"1").then((result) => {     //view report
                        let Records = result["Records"];
                        window.open(Records, '', 'height=400,width=600');
                      });
                      
                    }
                    else {
                      this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                    
                    }
                  }
                  this.navCtrl.setRoot(B05PurchaseOrderPage);
            
              }, (err) => {
                this.errorMessage = "Loading Error. Please try again.";
                this.loading.dismiss();
              });
            }
            else
            {
              this.errorMessage = "Branch ID Missing. Please try again.";
              this.loading.dismiss();
            }
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          this.loading.dismiss();
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
      });
      console.log(this.errorMessage);
    }
    else
    {
      this.errorMessage = "No Item Is Added";
    }
  }

  cancel()
  {
    this.navCtrl.setRoot(B05PurchaseOrderPage);
  }
  editPOL(id)
  {
    console.log(this.POL_Array[id]);
    let pol_val = this.POL_Array[id];
    this.selectedItem = pol_val["INVENTORY_ID"];
    this.selectedDescription = pol_val["POL_DESC"];
    this.selectedQuantity = pol_val["QTY"];
    this.selectedUnitCost = pol_val["UNIT_PRICE"];
    this.selectedDiscPercentage = pol_val["DISC_PERC"];
    this.selectedTaxPercentage = pol_val["TAX_PERC"];
    this.overlayHidden = false;
    this.selected_id = id;
  }
  hideOverlay() {
    
    this.overlayHidden = true;
    console.log("hide");
  }

  update()
  {
    let id = this.selected_id;
    //console.log(this.POL_Array[id]);
    //let pol_val = this.POL_Array[id];
    this.POL_Array[id]["INVENTORY_ID"] = this.selectedItem;
    this.POL_Array[id]["POL_DESC"] = this.selectedDescription;
    this.POL_Array[id]["QTY"] = this.selectedQuantity;
    this.POL_Array[id]["UNIT_PRICE"] = this.selectedUnitCost;
    this.POL_Array[id]["DISC_PERC"] = this.selectedDiscPercentage;
    this.POL_Array[id]["TAX_PERC"] = this.selectedTaxPercentage;

    let TOTAL_TAX = this.edittaxCalculate();
    let POL_TOTAL = this.editpolCalculate();
    let QTY_UNIT = (parseFloat(this.selectedQuantity)*parseFloat(this.selectedUnitCost));
    console.log("Tax"+TOTAL_TAX);
    console.log("POl"+POL_TOTAL);
    let GRAND_POL_TOTAL = QTY_UNIT + TOTAL_TAX - POL_TOTAL;
    console.log("GRAND_POL_TOTAL"+GRAND_POL_TOTAL);
   
    console.log(this.POsubtotal);
    console.log(this.POtaxtotal);
    this.POL_Array[id]["GRAND_POL_TOTAL"] = GRAND_POL_TOTAL;
    this.POL_Array[id]["POL_TOTAL"] = QTY_UNIT;
    this.POL_Array[id]["TOTAL_TAX"] = TOTAL_TAX;
    this.POsubtotal = this.subtotal();
    this.POtaxtotal = this.taxtotal();
    this.POgrandtotal = this.grandtotal();
   /* POL.TOTAL_TAX = TOTAL_TAX;
    console.log("TOTAL"+POL.TOTAL_TAX);
    POL.POL_TOTAL = POL_TOTAL;
    POL.GRAND_POL_TOTAL = GRAND_POL_TOTAL;*/
    this.overlayHidden = true;
  }
  edittaxCalculate()
  {
    if(this.selectedTaxPercentage == "")
      return 0;
    else
      return ((parseFloat(this.selectedQuantity)*parseFloat(this.selectedUnitCost))*((parseFloat(this.selectedTaxPercentage)/100)));
  }
  editpolCalculate()
  {
    if(this.selectedDiscPercentage == "")
      return 0;
    else
      return ((parseFloat(this.selectedQuantity)*parseFloat(this.selectedUnitCost))*((parseFloat(this.selectedDiscPercentage)/100)));
  }
}



// WEBPACK FOOTER //
// ./src/pages/b05b-purchase-add/b05b-purchase-add.ts